// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 1001; }

.modal-content {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--White);
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 4px; }

.modal-cross {
  position: absolute;
  top: 26px;
  right: 26px;
  color: var(--HightEmphasis);
  cursor: pointer;
  z-index: 1; }
  .modal-cross:hover {
    color: var(--MediumEmphasis); }

.modal-cross_substrate {
  width: 40px;
  height: 40px;
  top: 0px;
  right: -45px;
  border-radius: 50%;
  padding: 10px;
  color: var(--White);
  background-color: rgba(33, 33, 33, 0.7); }
`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,UAAU,EAAA;EANZ;IAQI,4BAA4B,EAAA;;AAIhC;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uCAAuC,EAAA","sourcesContent":[".modal {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease-in-out;\n  overflow: hidden;\n  z-index: 1001;\n}\n\n.modal-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-color: var(--White);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.modal-cross {\n  position: absolute;\n  top: 26px;\n  right: 26px;\n  color: var(--HightEmphasis);\n  cursor: pointer;\n  z-index: 1;\n  &:hover {\n    color: var(--MediumEmphasis);\n  }\n}\n\n.modal-cross_substrate {\n  width: 40px;\n  height: 40px;\n  top: 0px;\n  right: -45px;\n  border-radius: 50%;\n  padding: 10px;\n  color: var(--White);\n  background-color: rgba(33, 33, 33, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
